import { useLocalStore } from 'mobx-react-lite';
import { FC, useEffect } from 'react';

import Tasks from 'APP/Tasks';
import ProfileView from 'APP/main/RightSidebarManager/components/ProfileView';
import { Group } from 'APP/store/Groups/Group';
import Entities from 'STORE';

interface IChatInfoPresenter {
  isAvailableToShow: boolean;
  group: Group | null;
  toggleProfileSidebar(): void;
  onClose(): void;
}

export const useChatInfoPresenter = (): IChatInfoPresenter => {
  // TODO: нужно вырезать toggleSidebar из ChatStore и все что с этим связанно переделать на RightSidebar
  const presenter = useLocalStore(() => ({
    get isAvailableToShow(): boolean {
      return Entities.ChatStore.isShowSidebar;
    },

    get group(): Group | null {
      return Entities.GroupsStore.activeGroup;
    },

    onClose(): void {
      return Entities.ChatStore.hideSidebar();
    },

    toggleProfileSidebar(): void {
      if (presenter.group?.isServiceMessages) {
        return;
      }

      Entities.ChatStore.toggleSidebar();
    },
  }));

  useEffect(() => {
    if (presenter.isAvailableToShow && presenter.group) {
      Tasks.app.openRightSidebarItem('profileView', ProfileView as FC, {
        groupId: presenter.group.id,
        onClose: presenter.onClose,
      });
      return;
    }

    Tasks.app.closeRightSidebarItem('profileView');
  }, [presenter.isAvailableToShow]);

  useEffect(() => {
    return () => {
      Tasks.app.closeRightSidebarItem('profileView');
    };
  }, []);

  return presenter;
};
